import React from 'react'
import {Tabs} from '@therms/atalaya'
import {CheckpointsList} from './components/CheckpointsList'
import {CheckpointTourRunsList} from './components/CheckpointTourRunsList'
import {CheckpointScansList} from './components/CheckpointScansList'
import {useLocationContext, useTabsState} from '@therms/react-modules'

function CheckpointsTab() {
  const {locationId} = useLocationContext(true)
  const [tab, setTab] = useTabsState(`${locationId}_chkptabs`, 'Scans')

  return (
    <Tabs initialTabKey={tab} onTabClick={setTab}>
      <Tabs.Tab title="Checkpoints">
        <CheckpointsList />
      </Tabs.Tab>

      <Tabs.Tab title="Tours">
        <CheckpointTourRunsList />
      </Tabs.Tab>

      <Tabs.Tab title="Scans">
        <CheckpointScansList />
      </Tabs.Tab>
    </Tabs>
  )
}

export {CheckpointsTab}
